var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"observe-cover"},[_c('cover-map'),_c('cover-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }